export enum STORAGE {
  TOKEN = 'token',
  LOCALE = 'locale',
}
